import './subs.css';
import Form from '../form/Form';


const Subs = () => {
   return (
      <section className="subs">
         <div className="container">
            <div className="subs__body">
               <h2 className='subs__title'>JOIN SHOPPING COMMUNITY TO <br /> GET MONTHLY PROMO</h2>
               <div className="subs__text">Type your email down below and be young wild generation</div>
               <div className="subs__form">
                  <Form />
               </div>
            </div>
         </div>
      </section>
   );
}

export default Subs;